import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import { Dropdown } from "primeng/dropdown";
import { environment } from 'src/environments/environment';
import * as moment from "moment";
import { TournamentsService } from 'src/app/services/tournamnet.service';
import { AcademyService } from '../academies/service/academies.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './tournamentlist.component.html',
    styleUrls: ['./tournamentlist.component.scss'],
    styles: [`
        :host ::ng-deep .p-datatable-gridlines p-progressBar {
            width: 100%;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class TournamentListComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    errorMessage = '';
    statuses: any[];
    searchBy: any[];
    rowGroupMetadata: any;
    totalRecords: 0;
    virtualDatabase: any;
    academyTournamentsList: any;
    userRoleId;
    userdetail: any;
    public item: any[] = [];
    public academyName;
    loading: boolean;
    paginationOption;
    private lazyLoadEvent: LazyLoadEvent;
    calvalue: Date;
    ucalvalue: Date;
    dcalvalue: Date;
    yearRange;
    minYear = environment.minYear;
    stDate: Date = new Date();
    startDate: Date;
    endDate: Date;
    downloadFlg: boolean;
    downloadAcademyTournamentsList: any;
    searchby;
    wdcalvalue;
    public hide: boolean = true;
    public catList: any[] = [];
    public brandList: any[] = [];
    public showFileUploadModal: boolean = false;
    public academyCsvFile;
    public uploadCsvFile: any[] = [];
    public academyImages: any[] = [];
    public uploadImageFiles: any[] = [];
    public showFileErrors: boolean = false;
    public showImageFileUploadModal: boolean = false;
    public showImageFileErrors: boolean = false;
    public editTransaction: boolean = false;
    public academyId;
    public transvalue;
    public lastdateofregistrationvalue;
    public lastdateofwithdraw;
    public startdatevalue;
    public enddatevalue;
    public expiryvalue;
    public academyDetails;
    public transactionSubmitted: boolean = false;
    public minimumDate = new Date();
    @ViewChild("dt", { static: false }) public dt: Table;
    @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
    navigateTo: any;
    constructor(private academyTournamentService: TournamentsService, private router: Router, private messageService: MessageService, private confirmationService: ConfirmationService,
        private activeroute: ActivatedRoute,
        private academyService: AcademyService
    ) { }

    ngOnInit() {
        this.paginationOption = environment.pagination;
        this.academyId = this.activeroute.snapshot.params.id;
        this.navigateTo = this.activeroute.snapshot.queryParamMap.get('redirect');
        this.yearRange = environment.yearRange;
        this.statuses = [
            { label: 'Active', value: true },
            { label: 'In-Active', value: false },
        ];
        this.searchBy = [
            { label: 'Created On', value: "created_at" },
            { label: 'Last Modified On', value: "updated_at" }
        ];
        this.downloadFlg = false;
    }

    clear() {
        this.startDate = null;
        this.endDate = null;
        this.searchby = '';
        this.dt.filter('', 'academyName', 'contains');
        this.dt.filter('', 'name', 'contains');
        this.dt.filter('', 'lastdateofwithdraw', 'dateIs');
        this.dt.filter('', 'lastdateofregistration', 'dateIs');
        this.dt.filter('', 'lastdateofwithdraw', 'dateIs');
        this.dt.filter('', 'startdate', 'dateIs');
        this.dt.filter('', 'enddate', 'dateIs');
        this.dt.filter('', 'created_at', 'dateIs');
        this.dt.filter('', 'createdby', 'contains');
        this.dt.filter('', 'updated_at', 'dateIs');
        this.dt.filter('', 'updatedby', 'contains');
        this.calvalue = null;
        this.ucalvalue = null;
        this.dcalvalue = null;
        this.wdcalvalue = null;
        this.pDropDownId.clear(null);
        if (this.pDropDownId) {
            this.pDropDownId.value = '';
        }
    }

    loadAcademyTournaments(event: LazyLoadEvent) {
        this.lazyLoadEvent = event;
        let query = "filterByDisable=false";
        let pagenumber = 1;
        let params = "";
        let rows;
        if (event.first != undefined && event.first == 0) {
            pagenumber = event.first + 1;
        } else if (event.first != undefined && event.first > 0) {
            pagenumber = (event.first / event.rows) + 1;
        } else {
            pagenumber = 1;
        }
        if (event.rows != undefined) {
            rows = event.rows;
        } else {
            rows = 10;
        }
        if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
            params += "&filterByDate=" + this.searchby.value;
            params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
            params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
        }
        if (this.navigateTo === 'deleteTournamentRequest') {
            params += "&filterByStatus=true&filterByDeleteRequest=true";
        } else {
            params += "&filterByStatus=false";
        }
        if (event.filters != undefined && event.filters["name"] != undefined) {
            params += "&filterByName=" + event.filters["name"].value;
        }
        if (event.filters != undefined && event.filters["academyName"] != undefined) {
            params += "&filterByAcademyName=" + event.filters["academyName"].value;
        }
        if (event.filters != undefined && event.filters["organizercontactnumber"] != undefined) {
            params += "&filterByOrganizerContactNumber=" + event.filters["organizercontactnumber"].value;
        }
        if (event.filters != undefined && event.filters["status"] != undefined) {
            params += "&filterByStatus=" + event.filters["status"].value;
        }
        if (event.filters != undefined && event.filters["lastdateofregistration"] != undefined) {
            const lastDateOfRegistration = moment(event.filters["lastdateofregistration"].value).format("YYYY-MM-DD");
            params += "&filterByLastDateOfRegistration=" + lastDateOfRegistration;
        }
        if (event.filters != undefined && event.filters["lastdateofwithdraw"] != undefined) {
            const lastDateOfWithdraw = moment(event.filters["lastdateofwithdraw"].value).format("YYYY-MM-DD");
            params += "&filterByLastDateOfWithdraw=" + lastDateOfWithdraw;
        }
        if (event.filters != undefined && event.filters["startdate"] != undefined) {
            const startDate = moment(event.filters["startdate"].value).format("YYYY-MM-DD");
            params += "&filterByStartDate=" + startDate;
        }
        if (event.filters != undefined && event.filters["enddate"] != undefined) {
            const endDate = moment(event.filters["enddate"].value).format("YYYY-MM-DD");
            params += "&filterByEndDate=" + endDate;
        }
        if (event.filters != undefined && event.filters["created_at"] != undefined) {
            const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
            params += "&filterByCreatedAt=" + createdAt;
        }
        if (event.filters != undefined && event.filters["createdby"] != undefined) {
            params += "&filterByCreatedby=" + event.filters["createdby"].value;
        }
        if (event.filters != undefined && event.filters["updated_at"] != undefined) {
            const createdAt = moment(event.filters["updated_at"].value).format("YYYY-MM-DD");
            params += "&filterByUpdatedAt=" + createdAt;
        }
        if (event.filters != undefined && event.filters["updatedby"] != undefined) {
            params += "&filterByUpdatedBy=" + event.filters["updatedby"].value;
        }

        if (this.downloadFlg == false) {
            if (params != undefined && params != "") {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
            } else {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
            }
        } else {
            if (params != undefined && params != "") {
                query += params;
            }
        }

        if (event.sortField != undefined && event.sortOrder != undefined) {
            let orderBy = "";
            if (event.sortOrder == 1) {
                orderBy = "DESC";
            } else {
                orderBy = "ASC";
            }
            query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
        }

        if (this.navigateTo === 'deleteTournamentRequest') {
            this.academyTournamentService.getTournamentDeleteRequests(query).pipe(takeUntil(this.destroy$)).subscribe(
                data => {
                    console.log(data, 'acedmy list')
                    this.loading = false;
                    this.academyTournamentsList = data?.data?.items;

                    this.totalRecords = data?.data?.totalCount;
                },
                err => {
                    this.errorMessage = err.error.message;
                })
        } else {
            this.academyTournamentService.getAcademyTournamentsList(query).pipe(takeUntil(this.destroy$)).subscribe(
                data => {
                    console.log(data, 'acedmy list')
                    this.loading = false;
                    this.academyTournamentsList = data?.data?.items;

                    this.totalRecords = data?.data?.totalCount;
                },
                err => {
                    this.errorMessage = err.error.message;
                });
        }
    }
    getAcademyDetails(id) {
        this.academyService.getAcademyDetails(id).pipe(takeUntil(this.destroy$)).subscribe(
            (data: any) => {
                this.loading = false;
                this.academyTournamentsList = data?.data?.items;
            },
            err => {
                this.errorMessage = err.error.message;
            });
    }

    editTournament(tournament) {

        //this.router.navigate(['/manage/academies/tournament/edit/' + this.academyTournamentsList[0].academyId+ '/' + tournament.id+'/0'],{ queryParams: { redirect: this.navigateTo}});
        this.router.navigate(['/manage/academies/tournament/edit/' + tournament.academyId + '/' + tournament.id + '/0'], { queryParams: { redirect: this.navigateTo } });
    }

    viewTournamentPlayerList(tournament) {
        this.router.navigate(['/manage/academies/tournament/player-list/' + tournament.academyId + '/' + tournament.id + '/0'], { queryParams: { redirect: this.navigateTo } });
    }

    findIndexById(id: string): number {
        let index = -1;
        for (let i = 0; i < this.academyTournamentsList.length; i++) {
            if (this.academyTournamentsList[i].id === id) {
                index = i;
                break;
            }
        }
        return index;
    }



    setDownloadFlag() {
        this.downloadFlg = false;
    }
    addColumns() {
        this.hide = false;
    }
    removeColumns() {
        this.hide = true;
    }

    changeStatus(data) {
        this.confirmationService.confirm({
            message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to change this status ?
      </p>
    `,

            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Confirm',
            rejectLabel: 'Cancel',
            // ❌ Remove icons
            acceptIcon: '',
            rejectIcon: '',

            // message: 'Are you sure you want to change the status of  ' + (this.titlecasePipe.transform(data.name)) + '?',
            // header: 'Confirm',
            // icon: 'pi pi-exclamation-triangle',
            accept: () => {
                var updateData = '{"status":' + data.status + '}';
                this.academyTournamentService.updateTournament(data.id, updateData).pipe(takeUntil(this.destroy$)).subscribe(
                    data => {
                        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Tournament Status Updated', life: 3000 });
                        this.loadAcademyTournaments(this.lazyLoadEvent);
                    },
                    err => {
                        this.errorMessage = err.error.message;
                    }
                );
            },
            reject: () => {
                this.loadAcademyTournaments(this.lazyLoadEvent);
            }
        });
    }
    deleteTournament(data) {
        this.confirmationService.confirm({
            message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete this ?
      </p>
    `,

            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Confirm',
            rejectLabel: 'Cancel',
            // ❌ Remove icons
            acceptIcon: '',
            rejectIcon: '',

            // message: 'Are you sure you want to delete ' + (this.titlecasePipe.transform(data.name)) + '?',
            // header: 'Confirm',
            // icon: 'pi pi-exclamation-triangle',
            accept: () => {
                let disableStatus;
                if (data.disable == false) {
                    disableStatus = true;
                } else {
                    disableStatus = false;
                }
                let updatedata = '{"disable":' + disableStatus + '}';
                this.academyTournamentService.updateTournament(data.id, updatedata).pipe(takeUntil(this.destroy$)).subscribe(
                    data => {
                        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Tournament Deleted', life: 3000 });
                        this.loadAcademyTournaments(this.lazyLoadEvent);
                    },
                    err => {
                        this.errorMessage = err.error.message;
                    }
                );
            },
            reject: () => {
                this.loadAcademyTournaments(this.lazyLoadEvent);
            }
        });
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
}
